import TwoFASetup from './TwoFASetup';
import TwoFA from './TwoFA';
import TwoFASecurityModal from './TwoFASecurityModal';
import TwoFAOtpModal from './TwoFAOtpModal';
export default TwoFA;
export { TwoFASetup, TwoFASecurityModal, TwoFAOtpModal };
